import { pdfjsLib } from './pdfWorker';

export async function convertPdfToImage(pdfFile: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = async (e) => {
      try {
        const typedArray = new Uint8Array(e.target?.result as ArrayBuffer);
        
        console.log('Loading PDF document...');
        const loadingTask = pdfjsLib.getDocument({ data: typedArray });
        const pdf = await loadingTask.promise;
        
        console.log(`PDF loaded successfully. Pages: ${pdf.numPages}`);
        const page = await pdf.getPage(1);
        
        const viewport = page.getViewport({ scale: 2.0 });
        console.log(`Rendering page 1 at ${viewport.width}x${viewport.height}`);
        
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        
        if (!context) {
          throw new Error('Could not get canvas context');
        }
        
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        
        const renderContext = {
          canvasContext: context,
          viewport: viewport
        };
        
        await page.render(renderContext).promise;
        console.log('Page rendered successfully');
        
        const imageData = canvas.toDataURL('image/png');
        console.log('Converted to image, size:', imageData.length);
        resolve(imageData);
      } catch (error) {
        console.error('PDF conversion detailed error:', error);
        const errorMessage = error instanceof Error ? error.message : 'Unknown error';
        reject(new Error(`Failed to convert PDF: ${errorMessage}`));
      }
    };
    
    reader.onerror = (error) => {
      console.error('FileReader error:', error);
      reject(new Error('Failed to read PDF file'));
    };
    reader.readAsArrayBuffer(pdfFile);
  });
}

export function dataURLtoFile(dataUrl: string, filename: string): File {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/png';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
